import type { Modules } from '../../modules/_definition/types';

export class ModuleDisabledError extends Error {
    module: Modules;

    constructor(module: Modules) {
        super();
        this.module = module;
        this.name = 'ModuleDisabledError';
    }
}
